import {
  ABMSvg,
  AmpUpSvg,
  ApplegreenSvg,
  BPPulseSvg,
  BlinkSvg,
  ChargeLabSvg,
  ChargeNetSvg,
  ChargePointSvg,
  ChargeUpSvg,
  ChargieSvg,
  CircleKSvg,
  CircuitElectriqueSvg,
  EVCSSvg,
  EVConnectSvg,
  EVGatewaySvg,
  EVPowerSvg,
  EVRangeSvg,
  EVgoSvg,
  ElectrifyAmericaSvg,
  FPLEVSvg,
  FloSvg,
  FordChargeSvg,
  FrancisEnergySvg,
  GMUltiumSvg,
  GravitiSvg,
  JuleSvg,
  LivingstonSvg,
  LoopSvg,
  MercedesBenzSvg,
  NonNetworkedSvg,
  NoodoeSvg,
  OPConnectSvg,
  PowerNodeSvg,
  PowerflexSvg,
  RedESvg,
  RevelSvg,
  RivianSvg,
  RoveSvg,
  SevenChargeSvg,
  ShellRechargeSvg,
  SwtchSvg,
  TeslaSvg,
  UniversalSvg,
  VoltaSvg,
  WalmartSvg,
  WaveSvg,
  ZefNetSvg,
} from '@application/assets';
import { NetworkCode } from '@domain/graphql.types';
import { Box, SxProps, Theme } from '@mui/material';

const networkIconMap = new Map([
  [NetworkCode.Abm, ABMSvg],
  [NetworkCode.Ampup, AmpUpSvg],
  [NetworkCode.Applegreen, ApplegreenSvg],
  [NetworkCode.Blink, BlinkSvg],
  [NetworkCode.BpPulse, BPPulseSvg],
  [NetworkCode.Chargelab, ChargeLabSvg],
  [NetworkCode.Chargenet, ChargeNetSvg],
  [NetworkCode.ChargePoint, ChargePointSvg],
  [NetworkCode.Chargeup, ChargeUpSvg],
  [NetworkCode.Chargie, ChargieSvg],
  [NetworkCode.CircleK, CircleKSvg],
  [NetworkCode.CircuitElectrique, CircuitElectriqueSvg],
  [NetworkCode.ElectrifyAmerica, ElectrifyAmericaSvg],
  [NetworkCode.ElectrifyCanada, ElectrifyAmericaSvg],
  [NetworkCode.EvConnect, EVConnectSvg],
  [NetworkCode.Evcs, EVCSSvg],
  [NetworkCode.Evgateway, EVGatewaySvg],
  [NetworkCode.Evgo, EVgoSvg],
  [NetworkCode.EvPower, EVPowerSvg],
  [NetworkCode.EvRange, EVRangeSvg],
  [NetworkCode.Flo, FloSvg],
  [NetworkCode.FordCharge, FordChargeSvg],
  [NetworkCode.Fplev, FPLEVSvg],
  [NetworkCode.Fcn, FrancisEnergySvg],
  [NetworkCode.GmUltium, GMUltiumSvg],
  [NetworkCode.GravitiEnergy, GravitiSvg],
  [NetworkCode.Jule, JuleSvg],
  [NetworkCode.Livingston, LivingstonSvg],
  [NetworkCode.Loop, LoopSvg],
  [NetworkCode.MercedesBenz, MercedesBenzSvg],
  [NetworkCode.Noodoe, NoodoeSvg],
  [NetworkCode.OpConnect, OPConnectSvg],
  [NetworkCode.Powerflex, PowerflexSvg],
  [NetworkCode.PowerNode, PowerNodeSvg],
  [NetworkCode.RedE, RedESvg],
  [NetworkCode.Revel, RevelSvg],
  [NetworkCode.Rove, RoveSvg],
  [NetworkCode.RivianAdventure, RivianSvg],
  [NetworkCode.SevenCharge, SevenChargeSvg],
  [NetworkCode.ShellRecharge, ShellRechargeSvg],
  [NetworkCode.Swtch, SwtchSvg],
  [NetworkCode.Tesla, TeslaSvg],
  [NetworkCode.Universal, UniversalSvg],
  [NetworkCode.Volta, VoltaSvg],
  [NetworkCode.Walmart, WalmartSvg],
  [NetworkCode.Wave, WaveSvg],
  [NetworkCode.Zefnet, ZefNetSvg],
  [NetworkCode.NonNetworked, NonNetworkedSvg],
]);

type Props = {
  networkCode: NetworkCode;
  iconUrl?: string;
  sx?: SxProps<Theme>;
};

const NetworkIcon = ({ networkCode, iconUrl, sx }: Props) => {
  let networkIcon = networkIconMap.get(networkCode) || iconUrl;

  if (!networkIcon) {
    networkIcon = NonNetworkedSvg;
  }

  return <Box sx={sx} component="img" alt={networkCode} src={networkIcon} />;
};

export default NetworkIcon;
